import exceljs from "exceljs";
import { saveAs } from "file-saver";
import i18n from "@/plugins/vue-i18n";
import moment from "moment";
export class ExportAreaInterest {
  static async saveFile(workbook, fileName) {
    const buffer = await workbook.xlsx.writeBuffer();
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const fileExtension = ".xlsx";
    const blob = new Blob([buffer], { type: fileType });
    return saveAs(blob, fileName + fileExtension);
  }

  static async exportAreaInterest(areaInterests){
    const workbook = new exceljs.Workbook();
    const worksheet = workbook.addWorksheet("sheet1");
    worksheet.columns = [
      {
        header: i18n.t('date'),
        key: 1,
        width: 20,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('market.customer_name_and_company'),
        key: 2,
        width: 30,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('account.phone_number'),
        key: 3,
        width: 20,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('customer.customer_type'),
        key: 4,
        width: 15,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('contract.start_date'),
        key: 5,
        width: 20,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('contract.end_date'),
        key: 6,
        width: 20,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('area.interested_stall'),
        key: 7,
        width: 10,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('product.product_in_sell'),
        key: 8,
        width: 20,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('area.stall_number'),
        key: 9,
        width: 20,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('note'),
        key: 10,
        width: 20,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('status'),
        key: 11,
        width: 20,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },   
    ]
    for(let areaInterest of areaInterests){
      worksheet.addRow({
        1: areaInterest.createdAt ? new Date(moment(areaInterest.createdAt).format("YYYY-MM-DD")) : "",
        2: areaInterest.getCustomerName,
        3: areaInterest.customerTel,
        4: areaInterest.customerTypeString,
        5: areaInterest.contractStartDate ? new Date(moment(areaInterest.contractStartDate).format("YYYY-MM-DD")) : "",
        6: areaInterest.contractEndDate ? new Date(moment(areaInterest.contractEndDate).format("YYYY-MM-DD")) : "",
        7: areaInterest.areasQty,
        8: areaInterest.productNames.join(","),
        9: areaInterest.areasString,
        10: areaInterest.note,
        11: areaInterest.getStatusString,
      })
    }

    return this.saveFile(workbook, `area-interest`);
  }
}